globalThis.backoffice = globalThis.backoffice || {};

$(function() {
  backoffice.initDatePickers = function($container) {
    $container.find('.daterangepicker').each(function() {
      var $this = $(this);
      var options = $this.data('daterangepicker-options') || {};
      var defaults = {
        singleDatePicker: false,
        showDropdowns: true,
        autoApply: true,
        autoUpdateInput: false,
        locale: {
          format: 'DD/MM/YYYY'
        }
      }

      $this.daterangepicker(
        $.extend({}, defaults, options)
      );
    });

    $container.find('.datepicker').each(function() {
      var $this = $(this);
      var options = $this.data('daterangepicker-options') || {};
      var defaults = {
        singleDatePicker: true,
        showDropdowns: true,
        autoApply: true,
        autoUpdateInput: false,
        locale: {
          format: 'DD/MM/YYYY'
        }
      }

      $this.daterangepicker(
        $.extend({}, defaults, options, true),
        function(start, end, label) {
          window.preventHidingDropdowns = true;
          $this.val(start.format(this.locale.format)).change();
        }
      );
    });

    $container.find('.datepicker, .datetimepicker').on('show.daterangepicker', function(e, picker) {
      var $this = $(this),
          daterangepicker = $this.data('daterangepicker');

      window.currentDatepickerElement = $this;
      var $singleCalendar = $(daterangepicker.container).find('.calendar.left.single');

      if(!daterangepicker.autoApply && $singleCalendar.length && $singleCalendar.find('.apply').length == 0) {
        //$singleCalendar.append('<button class="apply btn btn-sm btn-success full-width" type="button">Valider</button>');
      }
    });

    $container.find('.datetimepicker').each(function() {
      var $this = $(this);
      var options = $this.data('daterangepicker-options') || {};
      var defaults = {
        singleDatePicker: true,
        showDropdowns: true,
        autoApply: true,
        autoUpdateInput: false,
        timePicker: true,
        timePicker24Hour: true,
        timePickerIncrement: 5,
        locale: {
          format: 'DD/MM/YYYY HH:mm'
        }
      }

      $this.daterangepicker(
        $.extend({}, defaults, options, true),
        function(start, end, label) {
          window.preventHidingDropdowns = true;
          $this.val(start.format(this.locale.format)).change();
        }
      );
    });

    $container.find('.datepicker, .datetimepicker').on('apply.daterangepicker', function(e, picker) {
      $(this).val(picker.startDate.format(picker.locale.format)).change();
    });

    $container.find('.daterangepicker .calendar').on('click.daterangepicker', 'td.available', function() {
      var daterangepicker = null;

      if(window.currentDatepickerElement) {
        var daterangepicker = window.currentDatepickerElement.data('daterangepicker');
      }

      if(daterangepicker && daterangepicker.timePicker) {
        window.preventHidingDropdowns = true;
      }

      if($(this).hasClass('active')) {
        if(daterangepicker) {
          daterangepicker.oldStartDate = daterangepicker.startDate.clone().subtract('1', 'days');

          window.preventHidingDropdowns = true;
        }
      }

      window.currentDatepickerElement.trigger('apply.daterangepicker', window.currentDatepickerElement.data('daterangepicker'));
    });

    $container.find('.daterangepicker .calendar').on('change.daterangepicker', 'select.hourselect, select.minuteselect', function(e, picker) {
      window.currentDatepickerElement.trigger('apply.daterangepicker', window.currentDatepickerElement.data('daterangepicker'));
    });

    $container.find('.daterangepicker .calendar').on('click.daterangepicker', 'th.available', function() {
      window.preventHidingDropdowns = true;
    });

    $container.on('click', '.daterangepicker.show-calendar select, .daterangepicker.show-calendar .calendar.left.single .apply', function() {
      window.preventHidingDropdowns = true;

      if($(this).hasClass('apply')) {
        window.currentDatepickerElement.trigger('apply.daterangepicker', window.currentDatepickerElement.data('daterangepicker'));
        window.currentDatepickerElement.data('daterangepicker').hide();
      }
    });
  }

  backoffice.initDatePickers($('body'));
});
